import React, { Component } from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import numberWithSpaces from '../../scripts/NumberWithSpaces.js';
// img
import event from '../../assets/icons/event.svg';
import eventAccent from '../../assets/icons/event-accent-light.svg';
import institution from '../../assets/icons/institution.svg';
import institutionAccent from '../../assets/icons/institution-accent-light.svg';
import journal from '../../assets/icons/journal.svg';
import journalAccent from '../../assets/icons/journal-accent-light.svg';
import person from '../../assets/icons/person.svg';
import personAccent from '../../assets/icons/person-accent-light.svg';
import records from '../../assets/icons/records.svg';
import recordsAccent from '../../assets/icons/records-accent-light.svg';
import works from '../../assets/icons/work.svg';
import worksAccent from '../../assets/icons/work-accent-light.svg';
import series from '../../assets/icons/series.svg';
import seriesAccent from '../../assets/icons/series-accent.svg';
import eventSeries from '../../assets/icons/event-series.svg';
import eventSeriesAccent from '../../assets/icons/event-series-accent.svg';
import place from '../../assets/icons/place.svg';
import placeAccent from '../../assets/icons/place-accent-light.svg';

class SimpleSearchResultsTab extends Component {
    constructor() {
      super();
      this.state = {
         imgName: ''
      };
    };

    getImgField= (name) => {
        switch (name) {
            case 'event':
                return event;
            case 'institution':
                return institution;
            case 'journal':
                return journal;
            case 'person':
                return person;
            case 'records':
                return records;
            case 'creative-work':
                return works;
            case 'series':
                return series;
            case 'event-series':
                return eventSeries;
            case 'place':
                return place;
            default:
                return;
        }
    };

    getImgFieldAccent = (name) => {
        switch (name) {
            case 'event':
                return eventAccent;
            case 'institution':
                return institutionAccent;
            case 'journal':
                return journalAccent;
            case 'person':
                return personAccent;
            case 'records':
                return recordsAccent;
            case 'creative-work':
                return worksAccent;
            case 'series':
                return seriesAccent;
            case 'event-series':
                return eventSeriesAccent;
            case 'place':
                return placeAccent;
            default:
                return;
        }
    };

    componentDidMount() {
      const { name } = this.props
      this.setState({
        imgName: this.getImgField(name)
      })
    }

    mouseOver() {
        const { name } = this.props
        this.setState({
          imgName: this.getImgFieldAccent(name)
        })
    }

    mouseLeave() {
        const { name } = this.props
        this.setState({
          imgName: this.getImgField(name)
        })
    }

    render () {
      const { id, name, active, count, setActiveTab, clang, isMobileSmall } = this.props;
      const { imgName } = this.state;

      return (
          <li className={`results__tab results__tab-${id} ${active ? 'active' : ''}`} onClick={() => setActiveTab(name)}
            onMouseOver={() => this.mouseOver()}
            onFocus={() => this.mouseOver()}
            onMouseLeave={() => this.mouseLeave()}
            onBlur={() => this.mouseLeave()}>
            <button title={lang[clang].advanced_search.tabs[name]} tabIndex={!active ? 0 : -1}>
                <img className="results__tab-icon" src={imgName} alt="" />
                {(!isMobileSmall || (isMobileSmall && active)) &&
                    <span className="results__tab-name">{lang[clang].advanced_search.tabs[name]} </span>}
                <span className="results__tab-count">({!!count ? numberWithSpaces(count) : count})</span>
            </button>
          </li>
      );
    }
}


SimpleSearchResultsTab.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(SimpleSearchResultsTab);



// WEBPACK FOOTER //
// ./src/components/simple-search-results/SimpleSearchResultsTab.js